import React from "react";
import Test from "./test";

const info = {
  difficulty: "medium",
  title: "Flatten Array - 1",
  url: "faltten-array-1",
  problemNumber: 1,
  problem: React.lazy(() => import(`./problem`)),
  test: Test,
  starter: `/**
* @param {number[][]} arr
* @return {number[]}
*/
    
/**
* Do not change this function body
* Do your changes within the function 
*/

return function flattenArray(arr) {
  // your code goes here        
};
`,
};

export default info;
